import { TbPencil } from "react-icons/tb";
import { Input, InputRef } from "antd";
import styles from "./TopicTab.module.css";
import { useTopic } from "../../hooks/use-topics";
import { useEffect, useMemo, useState, useRef } from "react";
import { IoCheckmark } from "react-icons/io5";
import { BasicTab } from "./BaseTab";

export const TopicTab = () => {
  const {
    topic,
    topicTitle,
    topicType,
    activeTab,
    setActiveTab,
    isTitleTyping,
    setIsTitleTyping,
    updateTitle,

    hasWriteAccess
  } = useTopic();
  const [documentName, setDocumentName] = useState<string>("");
  const inputRef = useRef<InputRef>(null);

  useEffect(() => {
    if (topicType === "building-block" && topicTitle.includes("_")) {
      setDocumentName(topicTitle.replace("_", " (") + ")" || "");
    } else {
      setDocumentName(
        topicTitle.replace("Peak Outcome", "Peak Ambition") || ""
      );
    }
  }, [topicTitle, topicType]);

  const isTabActive = useMemo(() => {
    return activeTab === "Topic";
  }, [activeTab]);

  useEffect(() => {
    if (isTitleTyping && isTabActive && inputRef.current) {
      inputRef.current.focus();
    }
  }, [isTitleTyping, isTabActive]);

  useEffect(() => {
    setActiveTab("Topic");
  }, []);

  const ButtonElemenet = useMemo(() => {
    if (
      topicType === "building-block" ||
      topicType === "briefing-doc" ||
      !hasWriteAccess
    ) {
      return null;
    }

    const Icon = isTitleTyping ? IoCheckmark : TbPencil;

    if (documentName === "" && isTitleTyping) {
      return null;
    }

    return (
      <Icon
        size={20}
        style={{
          marginLeft: "10px",
          flexShrink: 0,
          cursor: "pointer"
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          if (isTitleTyping) {
            updateTitle({
              topicId: topic["_id"],
              title: documentName
            });
          }

          setIsTitleTyping((prev) => !prev);
        }}
      />
    );
  }, [isTitleTyping, documentName, topic, hasWriteAccess, topicType]);

  return (
    <BasicTab tooltip={documentName || "Untitled Document"} title={"Topic"}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          overflow: "hidden"
        }}
      >
        {isTabActive && isTitleTyping ? (
          <div style={{ width: "100%", minWidth: 0, overflow: "hidden" }}>
            <Input
              ref={inputRef}
              placeholder="Untitled Document"
              variant="borderless"
              value={documentName}
              onKeyDownCapture={(e) => {
                e.stopPropagation();
              }}
              onChange={(e) => {
                setDocumentName(e.target.value);
              }}
              onPressEnter={() => {
                // Save on Enter key
                if (documentName !== topic?.title) {
                  updateTitle({
                    topicId: topic["_id"],
                    title: documentName
                  });
                }

                setIsTitleTyping(false);
              }}
              onBlur={() => {
                // Save the title when blurring
                if (documentName !== topic?.title) {
                  updateTitle({
                    topicId: topic["_id"],
                    title: documentName
                  });
                }

                setIsTitleTyping(false);
              }}
              style={{
                width: "100%"
              }}
              className={styles.ellipsisInput}
            />
          </div>
        ) : (
          <p
            style={{
              margin: 0,
              padding: 0,
              fontSize: "13px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              maxWidth: "100%",
              cursor: null,
              userSelect: "none"
            }}
          >
            {documentName || "Untitled Document"}
          </p>
        )}
        {ButtonElemenet}
      </div>
    </BasicTab>
  );
};
